import { render, staticRenderFns } from "./pop_wtguide_email.vue?vue&type=template&id=0e38b00d&scoped=true&"
import script from "./pop_wtguide_email.vue?vue&type=script&lang=js&"
export * from "./pop_wtguide_email.vue?vue&type=script&lang=js&"
import style0 from "./pop_wtguide_email.vue?vue&type=style&index=0&id=0e38b00d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e38b00d",
  null
  
)

export default component.exports